var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndicatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.61 24.495C28.725 21.9 30 18.6 30 15C30 6.72 23.28 0 15 0C6.72 0 0 6.72 0 15C0 23.28 6.72 30 15 30C18.6 30 21.9 28.725 24.495 26.61C24.9 26.28 25.29 25.92 25.665 25.545C25.71 25.5 25.74 25.455 25.77 25.425C26.07 25.125 26.355 24.81 26.61 24.495ZM15 27C8.385 27 3 21.615 3 15C3 8.385 8.385 3 15 3C21.615 3 27 8.385 27 15C27 17.775 26.055 20.31 24.465 22.35L22.32 20.205C23.355 18.735 23.97 16.95 23.97 15.015C23.97 10.05 19.935 6.015 14.97 6.015C10.005 6.015 5.97 10.05 5.97 15.015C5.97 19.98 10.005 24.015 14.97 24.015C16.92 24.015 18.735 23.385 20.205 22.32L22.335 24.45C20.31 26.055 17.775 27 15 27ZM17.88 15.765C18.135 14.775 17.91 13.695 17.145 12.915L17.115 12.885C15.96 11.73 14.115 11.715 12.945 12.825C12.93 12.84 12.9 12.855 12.87 12.885C11.7 14.055 11.7 15.96 12.87 17.13L12.9 17.16C13.68 17.925 14.775 18.165 15.765 17.895L18.03 20.16C17.13 20.7 16.095 21.03 14.97 21.03C11.655 21.03 8.97 18.345 8.97 15.03C8.97 11.715 11.655 9.03 14.97 9.03C18.285 9.03 20.97 11.715 20.97 15.03C20.97 16.125 20.655 17.145 20.13 18.03L17.88 15.765Z",
    fill: "#019DF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorIcon);
export default __webpack_public_path__ + "static/media/indicator-icon.2ecd263ad2d984b529443401fad843b3.svg";
export { ForwardRef as ReactComponent };